
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846083995",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2222",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M781.824 207.488l100.48 289.6-357.824 358.4-357.824-358.4 100.48-289.6h514.752M826.368 113.792H222.72a31.232 31.232 0 0 0-29.504 20.992l-128 368.512a31.232 31.232 0 0 0 7.424 32l429.696 430.592a31.104 31.104 0 0 0 22.08 9.152 31.104 31.104 0 0 0 22.08-9.152l429.696-430.592a31.232 31.232 0 0 0 7.36-32l-128-368.512A31.232 31.232 0 0 0 826.048 113.792z",
        "p-id": "2223",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M388.8 386.112m46.848 0l177.664 0q46.848 0 46.848 46.848l0 0q0 46.848-46.848 46.848l-177.664 0q-46.848 0-46.848-46.848l0 0q0-46.848 46.848-46.848Z",
        "p-id": "2224",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  